import { useQuery } from "@tanstack/react-query";

import { api } from "shared/api";
const warranties = {
  decideLaterWarrantyPackage: {
    id: "",
    packageId: "decide_later",
    name: "Ik beslis later",
    description: "",
    price: 0,
    active: true,
    duration: 0,
    code: "",
  },
  noWarrantyPayNowPackage: {
    id: "",
    packageId: "no_package_now",
    name: "Nee, ik betaal zelf reparatie of vervanging buiten de wettelijke garantie",
    description: "",
    price: 0,
    active: true,
    duration: 0,
    code: "",
  },
  noWarrantyPayFullPackage: {
    id: "",
    packageId: "no_package_full",
    name: "Geen extra GewoonZeker, 1 jaar is voldoende voor mij",
    description: "",
    price: 0,
    active: true,
    duration: 0,
    code: "1jaar",
  },
};

export const useWarrantyData = (enabled = true) => {
  const warrantyPackagesDataRequest = useQuery({
    queryKey: ["getWarrantyPackages"],
    queryFn: async () => {
      const res = await api().gersGetWarrantyPackages();
      return res.data;
    },
    refetchOnWindowFocus: false,
    enabled,
    retry: 1,
  });

  return { warranties, warrantyPackagesDataRequest };
};
